import React from "react";
import {
  Text,
  SectionList,
  StyleSheet,
  View,
  Image,
  TouchableOpacity,
  Dimensions
} from "react-native";
import { useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import FooterBarWide from "./footerBarWide";
import Colors from "../utilities/Color.js";

export default function TransactionListWide() {
  const navigation = useNavigation();
  const originalData = useSelector(
    (state) => state.transaction.processedTransactions
  );
  const Item = ({ title }) => (
    <TouchableOpacity
      style={styles.container}
      onPress={() =>
        navigation.navigate("SpendingInsightsDetail", { transaction: title })
      }
    >
      <View
        style={[
          styles.item,
          title.transactionState != "pending"
            ? { backgroundColor: "#ffffff" }
            : { backgroundColor: "gray" },
        ]}
      >
        <View style={styles.colImage}>
          <Image
            style={styles.imageThumbnail}
            source={{ uri: title.partnerImageUrl }}
            resizeMode="contain"
          />
        </View>
        <View style={styles.colPartnerDetailes}>
          {/* <Text style={styles.titleCat}>{title.partnerCategoryName}</Text> */}
          <Text style={styles.titleName}>{title.partnerName}</Text>
          <Text style={styles.titleType}>
            {title.transactionState}
          </Text>
        </View>
        <View style={styles.colCategory}>
          <Text style={styles.titleCat}>{title.partnerCategoryName}</Text>
        </View>
        <View style={styles.colInvestedMoney}>
          <Text style={styles.titleInvested}>
            REWARD +${title.amountInvested.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
          </Text>
          <Text style={styles.titleDonated}>
            DONATED +${title.amountDonated.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
          </Text>
        </View>
        <View style={styles.colAmountPaid}>
          <Text style={styles.titlePaid}>
            -${title.totalAmountPaid.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
  return (
    <View>
      <SectionList
        style={styles.sectionList}
        //sections={Object.values(originalData)}
        sections={Object.values(originalData).reverse()}
        keyExtractor={(item, index) => item + index}
        renderItem={({ item }) => <Item title={item} />}
        renderSectionHeader={({ section: { title } }) => (
          <View style={styles.itemHeader}>
          <View style={styles.colImage}>
          </View>
            <View style={styles.colPartnerDetailes}>
              <Text style={styles.header}>{title}</Text>
            </View>
            <View style={styles.colCategory}>
              <Text style={styles.header}>Category</Text>
            </View>
            <View style={styles.colInvestedMoney}>
        </View>
            <View style={styles.colAmountHeader}>
              <Text style={styles.header}>Amount</Text>
            </View>
          </View>
        )}
        ListHeaderComponent={<View style={styles.listHeaderYellow}></View>}
        ListFooterComponent={FooterBarWide}
      />
    </View>
  );
}

const win = Dimensions.get("window");
var paddingLeft, paddingRight, mybackgroundColor
const width = win.width
if (width < 768) {
  paddingLeft = 15
  paddingRight = 15
  mybackgroundColor = "red"
} else if (768 < width && width < 880) {
  paddingLeft = 70
  paddingRight = 100
  mybackgroundColor = "green"
} else if (width > 880) {
  paddingLeft = 100
  paddingRight = 40
  mybackgroundColor = "pink"
}

const styles = StyleSheet.create({
  sectionList: {
    backgroundColor: Colors.MIDBLUE
  },

  listHeader: {
    height: 195,
  },

  listHeaderYellow: {
    height: 290,
  },

  container: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#dddddd",
  },
  item: {
    flex: 1,
    flexDirection: "row",
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: paddingRight,
    paddingLeft: paddingLeft,
    backgroundColor: "#ffffff",
  },
  itemHeader: {
    flex: 6,
    flexDirection: "row",
    paddingTop: 12,
    paddingBottom: 12,
    paddingRight: paddingRight,
    paddingLeft: paddingLeft,
  },
  colImage: {
    flex: 10,
  },
  colDateHeader: {
    flex: 20,
    // backgroundColor: "green",
    alignSelf: "center",
    justifyContent: "flex-start",
  },
  colInvestedMoney: {
    flex: 15,
    //flexDirection: "row",
    justifyContent: "center",
    alignSelf: "center",
  },
  colPartnerDetailes: {
    flex: 20,
    //  backgroundColor: "pink",
    alignSelf: "center",
  },
  colAmountPaid: {
    flex: 10,
    // backgroundColor: "yellow",
    alignSelf: "center",
    // paddingRight: 150,
  },
  colCategory: {
    flex: 20,
    // backgroundColor: "black",
    alignSelf: "center",
  },
  colCatHeader: {
    flex: 8,
    // backgroundColor: "blue",
  },
  colAmountHeader: {
    flex: 10,
    alignItems: "flex-end",
  },
  row: {
    padding: 15,
    marginBottom: 5,
    backgroundColor: "#ffffff",
  },
  rowDark: {
    padding: 15,
    marginBottom: 5,
    backgroundColor: "#ffffff",
  },
  header: {
    color: "#ffffff",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    // textAlign: "left",
  },
  imageThumbnail: {
    flex: 1,
    height: 50,
    width: 50,
    resizeMode: "contain",
    margin: 1,
  },

  titleCat: {
    color: "#666666",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    paddingBottom: 5,
  },

  titleName: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    textAlign: "left",
    paddingBottom: 5,
  },

  titleType: {
    color: "#666666",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "left",
  },

  titlePaid: {
    color: "#666666",
    fontFamily: "montserrat-regular",
    fontSize: 15,
    textAlign: "right",
    paddingBottom: 5,
  },

  titleInvested: {
    color: "#30829F",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "right",
    paddingBottom: 5,
  },

  titleDonated: {
    color: "#30829F",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "right",
  },
});
